export default __webpack_public_path__ + "static/media/Version (4) - Half-Blood Prince_20.c922d3e8.jpg";